//customerlist
import avatar1 from "assets/images/users/32/avatar-1.jpg";
import avatar2 from "assets/images/users/32/avatar-2.jpg";
import avatar3 from "assets/images/users/32/avatar-3.jpg";
import avatar4 from "assets/images/users/32/avatar-4.jpg";
import avatar5 from "assets/images/users/32/avatar-5.jpg";
import avatar6 from "assets/images/users/32/avatar-6.jpg";
import avatar7 from "assets/images/users/32/avatar-7.jpg";
import avatar8 from "assets/images/users/32/avatar-8.jpg";
import avatar9 from "assets/images/users/32/avatar-9.jpg";
import avatar10 from "assets/images/users/32/avatar-10.jpg";
import dummyimg from "assets/images/users/32/user-dummy-img.jpg";

//coustomerdatailsdata
import pImg1 from "assets/images/products/32/img-1.png";
import pImg2 from "assets/images/products/32/img-2.png";
import pImg3 from "assets/images/products/32/img-3.png";
import pImg4 from "assets/images/products/32/img-4.png";
import pImg5 from "assets/images/products/32/img-5.png";
import pImg6 from "assets/images/products/32/img-6.png";

const customerlist = [
    {
        id: 1,
        img: avatar2,
        name: "Javon Pouros",
        email: "rashawn@steex.com",
        phone: "+(253) 12345 67890",
        date: "28 Feb, 2023",
        status: "Unactive"
    }, {
        id: 2,
        img: avatar3,
        name: "Willy Gulgowski",
        email: "gulgowski@steex.com",
        phone: "+(152) 32165 49873",
        date: "20 Feb, 2023",
        status: "Block"
    }, {
        id: 3,
        img: avatar4,
        name: "Verona Mosciski",
        email: "vmosciski@steex.com",
        phone: "+(231) 14562 32165",
        date: "16 Feb, 2023",
        status: "Active"
    }, {
        id: 4,
        img: avatar5,
        name: "Vinnie Huels",
        email: "vinnie@steex.com",
        phone: "+(44) 98765 32104",
        date: "23 Jan, 2023",
        status: "Active"
    }, {
        id: 5,
        img: avatar6,
        name: "Deondre Huel",
        email: "rashawn@steex.com",
        phone: "+(251) 25874 13690",
        date: "17 Jan, 2023",
        status: "Active"
    }, {
        id: 6,
        img: avatar7,
        name: "Nelson Schaden",
        email: "nelson@steex.com",
        phone: "+(92) 67890 12345",
        date: "02 Feb, 2023",
        status: "Unactive"
    }, {
        id: 7,
        img: avatar8,
        name: "Juanita Price",
        email: "juanitaprice@steex.com",
        phone: "+(62) 35791 15935",
        date: "29 Dec, 2022",
        status: "Block"
    }, {
        id: 8,
        img: avatar9,
        name: "Mac Gyver",
        email: "macGyver@steex.com",
        phone: "+(251) 15935 35795",
        date: "24 Dec, 2022",
        status: "Active"
    }, {
        id: 9,
        img: avatar10,
        name: "Zachary Stokes",
        email: "zacharystokes@steex.com",
        phone: "+(532) 35795 15935",
        date: "14 Dec, 2022",
        status: "Active"
    }, {
        id: 10,
        img: dummyimg,
        name: "Sarai Schmidt",
        email: "sschmidt@steex.com",
        phone: "+(120) 15935 32165",
        date: "08 Dec, 2022",
        status: "Block"
    }, {
        id: 11,
        img: avatar1,
        name: "Ubaldo Bartell",
        email: "ubaldobartell@steex.com",
        phone: "+(105) 93521 23165",
        date: "01 Dec, 2022",
        status: "Unactive"
    }, {
        id: 12,
        img: avatar2,
        name: "Soledad Vandervort",
        email: "vandervort@steex.com",
        phone: "+(210) 95162 15935",
        date: "24 Nov, 2022",
        status: "Active"
    }, {
        id: 13,
        img: avatar3,
        name: "Marcelino Smith",
        email: "marcelino@steex.com",
        phone: "+(512) 34682 17935",
        date: "21 Nov, 2022",
        status: "Active"
    }
];

const coustomerdatailsdata = [
    {
        id: 1,
        img: pImg1,
        title: "Craft Women Black Sling Bag",
        star: 487,
        cart: 936,
        price: 15.99
    },
    {
        id: 2,
        img: pImg2,
        title: "Unique Men's Wrist Watch",
        star: 452,
        cart: 1420,
        price: 84.99
    },
    {
        id: 3,
        img: pImg3,
        title: "Twiala Floral Dress",
        star: 562,
        cart: 1348,
        price: 149.99
    },
    {
        id: 4,
        img: pImg4,
        title: "Tokyo Fancy Bomber Jacket",
        star: 644,
        cart: 1540,
        price: 245.00
    },
    {
        id: 5,
        img: pImg5,
        title: "Aster Dress 2XL / Royal Blue",
        star: 841,
        cart: 985,
        price: 74.63
    },
    {
        id: 6,
        img: pImg6,
        title: "Craft Women Black Sling Bag",
        star: 763,
        cart: 763,
        price: 245.74
    },

]

export { customerlist, coustomerdatailsdata };